module.exports = __webpack_public_path__ + "assets/alert.svg?bc8e0a6ca1c4eebcbf34d56f81ca4aaf";